import * as React from 'react';
import styled from '@emotion/styled';
import IconButton from '@mui/material/IconButton';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import ReactPortal from '../../../utils/portal/ReactPortal';

const StyledModalContainer = styled.div`
  position: fixed;
  top: 0;
  z-index: 100;
  width: 100vw;
  height: 100vh;
  background: rgba(189, 195, 199, 0.7);
`;

const StyledModalContent = styled.div`
  opacity: 1;
  background: rgba(255, 255, 255, 1);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 30%;
  min-height: 40%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 2rem;
  padding: 1.5rem;
`;

const StyledIconButton = styled(IconButton)`
  &:hover {
    color: #092c4c;
  }
`;

interface ModalContainerProps {
  children: React.ReactNode;
  isOpen: boolean;
  handleClose(): void;
}

const StyledCloseIconContainer = styled.div`
  display: flex;
  justify-content: end;
  width: 100%;
`;

const ModalContainer = ({ children, isOpen, handleClose }: ModalContainerProps) => {
  if (!isOpen) return null;
  return (
    <ReactPortal wrapperId="react-portal-modal-container">
      <StyledModalContainer>
        <StyledModalContent>
          <StyledCloseIconContainer>
            <StyledIconButton onClick={handleClose}>
              <CancelPresentationIcon />
            </StyledIconButton>
          </StyledCloseIconContainer>
          {children}
        </StyledModalContent>
      </StyledModalContainer>
    </ReactPortal>
  );
};

export default ModalContainer;
